import React, { Component, Fragment } from 'react'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash'
import Link from "gatsby-link"
import moment from 'moment'

import { media } from '../../styles/utils';
import { hoverState, padding, bgImage } from '../../styles/global';

class PostMeta extends Component {

    static defaultProps = {
    
    }

    state = {
 
	}
	
	getMainSection = () => {
		const { post } = this.props;
		let mainSection = find(post.sections, {isSub: false})

		if (mainSection) {
			return (
				<MetaCategory
					to={`/articles/${mainSection.slug}`}
				>
					{mainSection.name}
				</MetaCategory>
			)
		}
	}

	getFirstSubsection = () => {
		const { post } = this.props;
		let firstSubsection = find(post.sections, {isSub: true})

		if (firstSubsection) {
			return (
				<MetaCategory
					to={`/articles/${firstSubsection.slug}`}
				>
					{firstSubsection.name}
				</MetaCategory>
			)
		}
	}
    
    render() {
		const { post } = this.props;
		
        return (
            <Meta
                theme={post.theme}
            >

                <AuthorDate>

                    {/* Author */}
                
                    {post.acf && post.acf.author && (
                        <Fragment>
                            <Author>
                                {post.acf.author}
                            </Author>
                            <Dot/>
                        </Fragment>
                    )}

                    {/* Date */}

                    {post.publishedDate && (
                        <Fragment>
                            <Date>
                                {moment.unix(post.publishedDate).format('D MMMM YYYY')}
                            </Date>
                            <Dot/>
                        </Fragment>
                    )}

                </AuthorDate>

				<MetaCategories>
					{this.getMainSection()}
					{this.getFirstSubsection()}
				</MetaCategories>

            </Meta>
        )
    }
}

const Meta = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${props => {
		if (props.theme == 'light') return css`
			&, * {
				color: white;

				${Dot} {
					background: white;
				}

				${MetaCategory} {
					color: white;
					border: 2px solid white;
				}
			}
		`
	}}

	${media.desktopSmall`
		flex-flow: row wrap;
	`}
`

const metaText = css`
	font-family: 'GT America Expanded Bold';
	font-size: 12px;
	text-transform: uppercase;

	${media.phone`
		font-size: 10px;
	`}
`

const AuthorDate = styled.div`
	display: flex;
	align-items: center;

	${media.desktopSmall`
		justify-content: center;
		flex: 1 0 100%;
	`}
`

const Author = styled.div`
	${metaText};
`

const Date = styled.div`
	${metaText};
`

const Dot = styled.div`
	height: 4px;
	width: 4px;
	min-width: 4px;
	background: black;
	border-radius: 50%;
	margin: 0 10px;

	${media.desktopSmall`
		&:last-child {
			display: none;
		}
	`}
`

const MetaCategories = AuthorDate.extend`
	${media.desktopSmall`
		margin-top: 8px;
	`}
`

const MetaCategory = styled.div`
	padding: 0 6px;
	border: 2px solid black;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;	
	${metaText}
	font-size: 9px;
	color: black;
	padding-bottom: 1px;
	box-sizing: border-box;

	&:not(:last-child) {
		margin-right: 5px;
	}

	${media.phone`
		font-size: 8px;
		border: 1px solid black;
		height: 19px;
	`}
`

export default PostMeta;


// WEBPACK FOOTER //
// ./src/components/PostMeta/PostMeta.js